import * as jQuery from 'jquery';
import 'bootstrap';
window.jQuery = jQuery;
window.$ = jQuery;

window.app = {
    /**
     * Initialize.
     *
     */
    init() {
        if ($('.contact').length) this.initMap();
    },

    /**
     * Initialize map.
     *
     */
    initMap() {
        const map = L.map('map', {
            center: L.latLng([51.954800, 4.605730]),
            zoom: 13,
            minZoom: 10,
            maxZoom: 16
        })
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);
        L.marker([51.954800, 4.605730]).addTo(map)
            .bindPopup('Naastu')
            .openPopup();
        $(window).resize(() => {
            map.panTo(new L.LatLng(51.954800, 4.605730));
        });
    }
};

$(document).ready($.proxy(app.init, app));